import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchContractById } from '../apis/fetchContractById';
import type { contractData } from '../types/uploadContract';
import type { ApiResponse } from '../../../types/apiResponse';
import withPrefix from '../../../helpers/useQueryPrefix';

export const useFetchContractById = (id_contract?: number | null): UseQueryResult<contractData, Error> => {
	return useQuery<ApiResponse<contractData>, Error, contractData>({
		queryKey: withPrefix(['contract', id_contract]),
		queryFn: () => fetchContractById(id_contract as number),
		select: (response) => {
			if (response.status !== 200) {
				throw new Error(response.message);
			}
			return response.data as contractData;
		},
		enabled: !!id_contract,
	});
};
